export const ICONS = {
  checked: '/icons/checked.svg',
  message: '/icons/message.svg',
  credit: '/icons/credit.svg',
  support: '/icons/support.svg',
  chevronDown: '/icons/chevron-down.svg'
}
